var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGerman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.903 0H2.09699C0.93882 0 0 0.93882 0 2.09699V6.11494H28V2.09699C28 0.93882 27.0612 0 25.903 0Z",
    fill: "#464655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2474C0 17.4056 0.93882 18.3444 2.09699 18.3444H25.903C27.0611 18.3444 28 17.4056 28 16.2474V12.2295H0V16.2474Z",
    fill: "#FFE15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.11523H0V12.2298H28V6.11523Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerman);
export default __webpack_public_path__ + "static/media/german.0405585c.svg";
export { ForwardRef as ReactComponent };